/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHeroBannerFragment, HeroBannerFragment, FullHeroBannerFragment} from '@amblique/contentful/app/contentful/fragments/hero-banner';

/**
 * Get a single HeroBanner by ID (base - scalars only)
 */
export const getBaseHeroBannerById = gql`
  ${BaseHeroBannerFragment}

  query GetBaseHeroBannerById($id: String!, $locale: String!, $preview: Boolean) {
    heroBanner(id: $id, locale: $locale, preview: $preview) {
      ...BaseHeroBannerFragment
    }
  }
`;

/**
 * Get a single HeroBanner by ID (standard - 1 level deep)
 */
export const getHeroBannerById = gql`
  ${HeroBannerFragment}

  query GetHeroBannerById($id: String!, $locale: String!, $preview: Boolean) {
    heroBanner(id: $id, locale: $locale, preview: $preview) {
      ...HeroBannerFragment
    }
  }
`;

/**
 * Get a single HeroBanner by ID (full - 2 levels deep)
 */
export const getFullHeroBannerById = gql`
  ${FullHeroBannerFragment}

  query GetFullHeroBannerById($id: String!, $locale: String!, $preview: Boolean) {
    heroBanner(id: $id, locale: $locale, preview: $preview) {
      ...FullHeroBannerFragment
    }
  }
`;

/**
 * Get all HeroBanner entries with pagination (base - scalars only)
 */
export const getBaseHeroBanners = gql`
  ${BaseHeroBannerFragment}

  query GetBaseHeroBanners(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HeroBannerOrder]
    $where: HeroBannerFilter
    $preview: Boolean
  ) {
    heroBannerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...BaseHeroBannerFragment
      }
    }
  }
`;

/**
 * Get all HeroBanner entries with pagination (standard - 1 level deep)
 */
export const getHeroBanners = gql`
  ${HeroBannerFragment}

  query GetHeroBanners(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HeroBannerOrder]
    $where: HeroBannerFilter
    $preview: Boolean
  ) {
    heroBannerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...HeroBannerFragment
      }
    }
  }
`;

/**
 * Get all HeroBanner entries with pagination (full - 2 levels deep)
 */
export const getFullHeroBanners = gql`
  ${FullHeroBannerFragment}

  query GetFullHeroBanners(
    $locale: String
    $limit: Int
    $skip: Int
    $order: [HeroBannerOrder]
    $where: HeroBannerFilter
    $preview: Boolean
  ) {
    heroBannerCollection(
      locale: $locale
      limit: $limit
      skip: $skip
      order: $order
      where: $where
      preview: $preview
    ) {
      total
      skip
      limit
      items {
        ...FullHeroBannerFragment
      }
    }
  }
`;
